export function indian(odd: number): string {
  return (Math.floor((odd * 1000) / 10) - 100).toFixed(0)
}
